<template>
  <div class="edit">
    <div class="edit-content">
      <div class="edit-item edit-item2">使用说明：</div>
      <div class="edit-item edit-item2">
        添加套件，可打通智能财务，审批通过后自动生成支出；支持导入费用记录，包括语音识别、拍照识别、电子发票等
      </div>
      <div v-for="(ele, index) in editForm.formProps" :key="index">
        <template v-if="ele.name == 'formColumn'">
          <div v-for="(item, idx) in ele.formProps" :key="idx">
            <template v-if="item.label == '费用类型'">
              <div class="edit-item">
                <div class="title">费用类型<span> 自定义费用类型</span></div>

                <el-switch
                  v-model="item.show"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </div>
            </template>
            <template v-if="item.label == '费用说明'">
              <div class="edit-item">
                <div class="title">
                  费用说明<span> 用于费用的补充说明</span>
                </div>

                <el-switch
                  v-model="item.show"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  style="margin-left: 20px"
                  v-model="item.required"
                  >必填</el-checkbox
                >
              </div>
              <div class="edit-item">
                <div class="title">费用提示文字</div>
                <el-input
                  v-model="item.placeholder"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </template>
            <template v-if="item.label == '电子发票'">
              <div class="edit-item">
                <div class="title">
                  电子发票<span> 用于上传电子发票补充说明</span>
                </div>

                <el-switch
                  v-model="item.show"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  style="margin-left: 20px"
                  v-model="item.required"
                  >必填</el-checkbox
                >
              </div>
            </template>
            <template v-if="item.label == '附件'">
              <div class="edit-item">
                <div class="title">
                  附件<span> 用于上传相关文件补充说明</span>
                </div>

                <el-switch
                  v-model="item.show"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
                <el-checkbox
                  :true-label="1"
                  :false-label="0"
                  style="margin-left: 20px"
                  v-model="item.required"
                  >必填</el-checkbox
                >
              </div>
            </template>
          </div>
        </template>
        <template v-if="ele.label == '归属人'">
          <div class="edit-item">
            <div class="title">
              归属人<span> 报销金额归属人，用于基于员工统计收入支出的场景</span>
            </div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
            <el-checkbox
              :true-label="1"
              :false-label="0"
              style="margin-left: 20px"
              v-model="ele.required"
              >必填</el-checkbox
            >
          </div>
        </template>
        <template v-if="ele.label == '备注'">
          <div class="edit-item">
            <div class="title">备注<span> 用于转账的说明</span></div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
            <el-checkbox
              :true-label="1"
              :false-label="0"
              style="margin-left: 20px"
              v-model="ele.required"
              >必填</el-checkbox
            >
          </div>
          <div class="edit-item">
            <div class="title">备注提示文字</div>
            <el-input
              v-model="ele.placeholder"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </template>
        <template v-if="ele.label == '项目'">
          <div class="edit-item">
            <div class="title">
              项目<span> 可关联项目，便于项目维度统计</span>
            </div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
            <el-checkbox
              :true-label="1"
              :false-label="0"
              style="margin-left: 20px"
              v-model="ele.required"
              >必填</el-checkbox
            >
          </div>
        </template>
        <template v-if="ele.label == '客户'">
          <div class="edit-item">
            <div class="title">
              客户<span> 可关联客户，便于客户维度统计</span>
            </div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
            <el-checkbox
              :true-label="1"
              :false-label="0"
              style="margin-left: 20px"
              v-model="ele.required"
              >必填</el-checkbox
            >
          </div>
        </template>
        <template v-if="ele.label == '供应商'">
          <div class="edit-item">
            <div class="title">
              供应商<span> 可关联供应商，便于供应商维度统计</span>
            </div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
            <el-checkbox
              :true-label="1"
              :false-label="0"
              style="margin-left: 20px"
              v-model="ele.required"
              >必填</el-checkbox
            >
          </div>
        </template>
      </div>
      <!-- <div class="edit-item">
        <div class="title">
          关联支付
          <span>(允许审批单完成后，为财务生成支付单，可在线支付)</span>
        </div>
        <el-switch
          v-model="editForm.relation"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div> -->
      <div class="edit-item">
        <div class="title">
          参与打印
          <span>(如不勾选，打印时不显示该项)</span>
        </div>
        <el-switch
          v-model="editForm.pint"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect() {
      this.$emit("removeSelect");
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-item2 {
  font-size: 12px;
}
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  .title {
    margin-bottom: 12px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
